import { DestinationUrlInput } from 'features/campaign/campaign.types';
import { browseNodeValidator, dealsValidator, urlValidator } from 'features/campaign/campaign.util';
import { validateAsin } from 'utils';

/**
 * Regular expression patterns for ref tag sanitization:
 * - CONSECUTIVE_PUNCTUATION: Used to find consecutive underscores or hyphens to replace with single character
 * - ENDS_WITH_NON_ALPHA: Used to find trailing non-alphanumeric characters to remove
 * - INVALID_CHARACTERS: Used to find invalid characters to remove (keeps only letters, numbers, underscore, hyphen)
 */
export const REF_TAG_REGEX = <const>{
  CONSECUTIVE_PUNCTUATION: /([_-])+/gi,
  ENDS_WITH_NON_ALPHA: /[^a-zA-Z0-9]+$/g,
  INVALID_CHARACTERS: /[^a-zA-Z0-9_|-]/g,
};

/**
 * Regular expression patterns for parsing different types of urls
 * Each pattern is used to infer:
 * 1. The main identifier (ASIN, browse node, etc.) in the first group
 * 2. Optional ref tag in the second group (if any)
 */
export const URL_PATTERNS = {
  [DestinationUrlInput.ASIN]: /\/(?:dp|gp\/aw\/d)\/([^/]+)/, // desktop: /dp/, mobile: /gp/aw/d/
  [DestinationUrlInput.BROWSE_NODE]: /\/gp\/browse\.html\?node=([^&]+)/,
  [DestinationUrlInput.DEALS]: /\/deal\/([^?]+)/,
  [DestinationUrlInput.LINK]: /^(\/.*)/,
};

export const LINK_CONFIG = {
  [DestinationUrlInput.ASIN]: {
    path: 'dp',
    title: 'Link ASIN',
  },
  [DestinationUrlInput.BROWSE_NODE]: {
    path: 'gp/browse.html?node',
    title: 'Browse node',
  },
  [DestinationUrlInput.DEALS]: {
    path: 'deals',
    title: 'Deal ID(s)',
  },
  [DestinationUrlInput.LINK]: {
    path: '',
    title: 'Link',
  },
} as const;

export const LINK_VALIDATORS = {
  [DestinationUrlInput.ASIN]: validateAsin,
  [DestinationUrlInput.BROWSE_NODE]: browseNodeValidator,
  [DestinationUrlInput.LINK]: urlValidator,
  [DestinationUrlInput.DEALS]: dealsValidator,
} as const;
